// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1Wkr5","fullScreen":"style_fullScreen__3-jgl","overlay":"style_overlay__3OcLb"};